import { matchPath } from "react-router-dom";
import { daXemTour, danhDauDaXemTour } from "lib/tourDaXem";
import { buocChangThuMua } from "tours/luong/thuMua";
import { buocChangKho } from "tours/luong/kho";

/** Tour luồng lần đầu — một lần / tài khoản, theo vai trò. */
export const ID_LUONG_THU_MUA = "luong-thu-mua";
export const ID_LUONG_KHO = "luong-kho";

/**
 * Chỉ ép luồng cho vai trò hiện trường. Admin / kế toán / BGD giữ tour từng trang
 * (không bắt đi hết quy trình thu mua).
 */
export function chonLuongChoVaiTro(vaiTro) {
  if (vaiTro === "nhan_vien") return ID_LUONG_THU_MUA;
  if (vaiTro === "kho") return ID_LUONG_KHO;
  return null;
}

const CHANG_THU_MUA = [
  {
    key: "trang-chu",
    pageTourId: "trang-chu",
    tong: 5,
    so: 1,
    khop: (path) => !!matchPath({ path: "/", end: true }, path),
  },
  {
    key: "chon-chu-vuon",
    pageTourId: "thu-mua",
    tong: 5,
    so: 2,
    khop: (path) => !!matchPath({ path: "/thu-mua/chu-vuon", end: true }, path),
  },
  {
    key: "chon-vuon",
    pageTourId: "thu-mua-chon-vuon",
    tong: 5,
    so: 3,
    khop: (path) => !!matchPath({ path: "/thu-mua/:maChuVuon/vuon", end: true }, path),
  },
  {
    key: "form-thu-mua",
    pageTourId: "thu-mua-nhap",
    tong: 5,
    so: 4,
    khop: (path) => !!matchPath({ path: "/thu-mua/:maChuVuon/:maVuon/nhap", end: true }, path),
  },
  {
    key: "xac-nhan",
    pageTourId: "thu-mua-xac-nhan-thanh-toan",
    tong: 5,
    so: 5,
    khop: (path) => !!matchPath({ path: "/thu-mua/xac-nhan/:id", end: true }, path),
  },
];

const CHANG_KHO = [
  {
    key: "trang-chu",
    pageTourId: "trang-chu",
    tong: 3,
    so: 1,
    khop: (path) => !!matchPath({ path: "/", end: true }, path),
  },
  {
    key: "nhap-xuat",
    pageTourId: "kho-nhap-xuat-sot",
    tong: 3,
    so: 2,
    khop: (path) => !!matchPath({ path: "/kho/nhap-xuat-sot", end: true }, path),
  },
  {
    key: "lich-su",
    pageTourId: "kho-lich-su",
    tong: 3,
    so: 3,
    khop: (path) => !!matchPath({ path: "/kho/lich-su", end: true }, path),
  },
];

function danhSachChang(flowId) {
  if (flowId === ID_LUONG_THU_MUA) return CHANG_THU_MUA;
  if (flowId === ID_LUONG_KHO) return CHANG_KHO;
  return [];
}

function taoBuocChang(flowId, chang) {
  if (flowId === ID_LUONG_THU_MUA) return buocChangThuMua(chang.key, chang.so, chang.tong);
  if (flowId === ID_LUONG_KHO) return buocChangKho(chang.key, chang.so, chang.tong);
  return [];
}

/** Chặng khớp pathname hiện tại (nếu đang trong luồng chưa xem xong). */
export function timChangLuong(flowId, pathname) {
  const ds = danhSachChang(flowId);
  const chang = ds.find((c) => c.khop(pathname));
  if (!chang) return null;
  return {
    ...chang,
    laChangCuoi: chang.so === chang.tong,
    buoc: () => taoBuocChang(flowId, chang),
  };
}

/** Trang (page tourId) có thuộc luồng đang chờ của vai trò này không. */
export function trangBiLuongGiu(vaiTro, uid, pageTourId) {
  const flowId = chonLuongChoVaiTro(vaiTro);
  if (!flowId || !pageTourId) return false;
  if (daXemTour(flowId, uid)) return false;
  return danhSachChang(flowId).some((c) => c.pageTourId === pageTourId);
}

/** Đánh dấu xong cả luồng + các tour trang trong luồng (tránh mở lại ngay sau đó). */
export function danhDauHoanThanhLuong(flowId, uid) {
  danhDauDaXemTour(flowId, uid);
  danhSachChang(flowId).forEach((c) => danhDauDaXemTour(c.pageTourId, uid));
}

export function dangChoLuong(vaiTro, uid) {
  const flowId = chonLuongChoVaiTro(vaiTro);
  if (!flowId) return null;
  if (daXemTour(flowId, uid)) return null;
  return flowId;
}
